// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2w-Tp","visuallyhidden":"_2mh7W","hide-text":"_3vQ7X","center":"_3Pzi3","noprint":"_3NYCr","leadText":"BPM3p"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-lead-text/styles/LeadText.scss
 ** module id = 947
 ** module chunks = 1
 **/